const SITE_SETTINGS_KEY = "ekman_site_settings";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const defaultSiteSettings = {
  customerCareTitle: "Customer Care",
  customerCareEmail: "ekmanbyekta@gmail.com",
  customerCareHours: "Mon-Sat · 10:00 AM - 7:00 PM",
  topBannerText: "Welcome to Ekman.",
  autoRotateProductPhotos: true,
  autoRotateViewPage: false,
  instagramPostLinks: [],
  founderPhoto: "https://customer-assets.emergentagent.com/job_nature-science-skin/artifacts/rhwlw68k_1000181031.jpg",
  heroBanners: [],
  sectionBanners: {},
  sectionHeroImages: {
    "Bath Salts": "",
    "Body & Face Oils": "",
  },
  ordersEnabled: true,
};

let cachedSettings = null;

export const getSiteSettings = () => {
  if (cachedSettings) {
    return { ...defaultSiteSettings, ...cachedSettings };
  }
  if (typeof window === "undefined") {
    return defaultSiteSettings;
  }

  try {
    const rawSettings = localStorage.getItem(SITE_SETTINGS_KEY);
    if (!rawSettings) {
      return defaultSiteSettings;
    }
    return { ...defaultSiteSettings, ...JSON.parse(rawSettings) };
  } catch {
    return defaultSiteSettings;
  }
};

let hasFetchedSettings = false;

export const fetchSiteSettings = async () => {
  // Only fetch once per session
  if (hasFetchedSettings) return getSiteSettings();
  hasFetchedSettings = true;
  
  try {
    const response = await fetch(`${API}/site-settings`);
    if (response.ok) {
      const data = await response.json();
      cachedSettings = data.settings || {};
      localStorage.setItem(SITE_SETTINGS_KEY, JSON.stringify(cachedSettings));
      return { ...defaultSiteSettings, ...cachedSettings };
    }
  } catch {
    // Fall back to localStorage
  }
  return getSiteSettings();
};

export const saveSiteSettings = async (nextSettings) => {
  if (typeof window === "undefined") {
    return;
  }

  const merged = { ...defaultSiteSettings, ...nextSettings };
  cachedSettings = merged;
  localStorage.setItem(SITE_SETTINGS_KEY, JSON.stringify(merged));

  // Save to backend for cross-device sync
  try {
    await fetch(`${API}/site-settings`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ settings: merged }),
    });
  } catch {
    // Saved locally, will sync later
  }
};
